import { SET_UPLOAD_STATUS, SET_UPLOAD_PROGRESS } from "actions/ActionTypes";

const initialState = {
  uploadStatusById: {},
  uploadProgressById: {},
};

export default (state = initialState, action) => {
  const { type, itemId, status, uploadProgress } = action;

  switch (type) {
    case SET_UPLOAD_STATUS:
      return {
        ...state,
        uploadStatusById: {
          ...state.uploadStatusById,
          [itemId]: status,
        },
      };

    case SET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadProgressById: {
          ...state.uploadProgressById,
          [itemId]: uploadProgress,
        },
      };

    default:
      return state;
  }
};
